import { Routes } from '@angular/router';

import { authGuard, guestGuard } from '@core/guards';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'job' },
  {
    path: 'login',
    canActivate: [guestGuard],
    loadComponent: () => import('@features/auth/pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'job',
    canActivate: [authGuard],
    loadChildren: () => import('@features/job/job.routes').then((m) => m.JOB_ROUTES),
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@features/notification/pages/list/notification-list.page').then(
        (m) => m.NotificationListPage,
      ),
  },
  { path: '**', redirectTo: 'job' },
];
